// extracted by mini-css-extract-plugin
module.exports = {"label":"labelElement_label__1_x9Q"};